import { supabase } from './client';

// 2026-10-09 (PF-02): 42 titik memanggil auth.getUser() (= 1 request jaringan
// /auth/v1/user per panggilan; 8x per load halaman). Helper ini membaca sesi
// lokal (tanpa jaringan) + cache 30 detik + dedup promise bersamaan.
// Aman untuk UI-gating (id/role display); gate nyata tetap RLS per-query.
// JANGAN pakai untuk alur sensitif (MFA, ganti password, hapus akun) —
// di sana tetap getUser() (validasi server).
let cache: { user: any; at: number } | null = null;
let inflight: Promise<any> | null = null;

export async function getSessionUser(): Promise<any> {
    const now = Date.now();
    if (cache && now - cache.at < 30000) return cache.user;
    if (!inflight) {
        inflight = supabase.auth.getSession().then(({ data }: any) => {
            const user = data?.session?.user ?? null;
            cache = { user, at: Date.now() };
            inflight = null;
            return user;
        }).catch(() => {
            inflight = null;
            return cache?.user ?? null;
        });
    }
    return inflight;
}

export function clearSessionUserCache(): void {
    cache = null;
}
